/* NgRx */
import {createAction, props} from '@ngrx/store';
import {
  FetchNotificationListResponseModel,
  NotificationItemModel
} from "../model/notification-model";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[notifications] clear state';
export const ClearState = createAction(CLEAR_STATE);

//fetch notification list
const FETCH_NOTIFICATION_LIST_REQUEST = '[notifications] fetch notification list request'
export const FetchNotificationListRequest = createAction(FETCH_NOTIFICATION_LIST_REQUEST, props<{ payload: { pageNumber: number, sortOrder?: number, sortColumn?: string } }>());

const FETCH_NOTIFICATION_LIST_SUCCESS = '[notifications] fetch notification list success'
export const FetchNotificationListSuccess = createAction(FETCH_NOTIFICATION_LIST_SUCCESS, props<{ payload: FetchNotificationListResponseModel['response']['data'] }>());

const FETCH_NOTIFICATION_LIST_FAILURE = '[notifications] fetch notification list failure'
export const FetchNotificationListFailure = createAction(FETCH_NOTIFICATION_LIST_FAILURE);

const SEND_MARK_AS_CHECKED_NOTIFICATION_DATA = '[notifications] send mark as checked notification data '
export const SendMarkAsCheckedNotificationData = createAction(SEND_MARK_AS_CHECKED_NOTIFICATION_DATA, props<{ payload: { list: NotificationItemModel[] } }>())
